module.exports = function() {

  /**
   *  Validates a number.
   *
   *  @param cb The callback function.
   */
  this.main.number = function number(cb) {
    if(this.validates()) {
      this.required();
      this.type();
      this.range();
    }
    cb();
  }

}



//////////////////
// WEBPACK FOOTER
// ../node_modules/async-validate/plugin/number.js
// module id = 1377
// module chunks = 93